<section *ngIf="isShw()">
    <div class="page-header-area sec-overlay sec-overlay-black"
        style="background-image: url('../../../../assets/images/new-images/Inner-Banner.png'); background-repeat: no-repeat;">
        <div class="container pt--0 pb--0">
            <div class="row">
                <div class="col-12">
                    <div class="page-header-content">
                        <h2 class="title">Contact</h2>
                        <nav class="breadcrumb-area">
                            <ul class="breadcrumb justify-content-center">
                                <li><a href="index.html">Home</a></li>
                                <li class="breadcrumb-sep"> / </li>
                                <li>Contact</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<div class="row">
    <div class="col-xl-6">
        <iframe src="https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d777764.4846045037!2d36.9937134!3d-1.4527862!3m2!1i1024!2i768!4f13.1!2m1!1sKonza%20Technopolis%20Nairobi%20Kenya!5e1!3m2!1sen!2sin!4v1750252944354!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
    <div class="col-xl-4 mt-2">
        <div class="card">
            <div class="card-body">
                <label>Contact Details:</label>
                <div>
                    <p>The Cradle, Silicon Savanna, Konza Technopolis
                        P. O. Box 2440 - 00606 Nairobi, Kenya</p><br>
                        <a href="info@ouk.ac.ke">info@ouk.ac.ke</a>
                </div>
                <div>
                    <p>+254702 212 212 / +254703 211 211</p><br>
                    <p>0702 212 212 / 0703 211 211</p>
                </div>
                    </div>
                </div>
    </div>
</div>
 